import CustomButton from 'components/CustomInput/Button';
import CustomTable from 'components/CustomTable';
import TextHeader from 'components/CustomText/TextHeader';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import CustomDatePicker from 'components/Input/CustomDatePicker';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import useAttendanceMember from 'hooks/review/useAttendanceMember';
import styled from 'styled-components';

const SLayout = styled.div`
    padding: 15px;
`;

const SRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    & > div:nth-child(1) {
        width: 200px;
        flex-shrink: 0;
        font-weight: bold;
    }

    & > div:nth-child(2) {
        width: 400px;
    }
`;

const MeetingAttendance = () => {
    const { rows, columns } = useAttendanceMember();

    return (
        <SLayout>
            <TextHeader>Update Meeting Attendance</TextHeader>

            <div style={{ marginTop: 20 }}>
                <SRow>
                    <div>Type of Review: </div>
                    <div>
                        <CustomOutlineSelect value={'0'} choices={[{ key: '0', display: 'Full Review' }]} />
                    </div>
                </SRow>

                <SRow>
                    <div>Review Due Date: </div>
                    <div>
                        <CustomDatePicker
                            label={'Label'}
                            value={new Date()}
                            onChange={(date) => {
                                // setActualStartDate(date);
                            }}
                        />
                    </div>
                </SRow>
                <SRow>
                    <div>Review Meeting Date: </div>
                    <div>
                        <CustomDatePicker
                            label={'Label'}
                            value={new Date()}
                            onChange={(date) => {
                                // setActualStartDate(date);
                            }}
                        />
                    </div>
                </SRow>
                <SRow>
                    <div>Review Circulation Date: </div>
                    <div>
                        <CustomDatePicker
                            label={'Label'}
                            value={new Date()}
                            onChange={(date) => {
                                // setActualStartDate(date);
                            }}
                        />
                    </div>
                </SRow>
            </div>

            <div style={{ display: 'flex', marginTop: 20, alignItems: 'center' }}>
                <TextSubHeader>Panel Member Table:</TextSubHeader>
                <CustomButton style={{ marginLeft: 20 }}>Add</CustomButton>
            </div>

            <div style={{ marginTop: 20 }}>
                <CustomTable rows={rows} columns={columns} isEditAllow isDeleteAllow />
            </div>

            <div style={{ marginTop: 20 }}>
                <CustomButton>Submit</CustomButton>
            </div>
        </SLayout>
    );
};

export default MeetingAttendance;
